Revolution.Module.extend({
    NAME: "mde.main", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "myfunction", "runEqualHeight", "getHeightsForOffsets");

        //Example to call an external function
        //var UTILS = Revolution.get("mde._utils");
        //UTILS.equalheight($('.bk-mosaique .js-equal-height'));

        //prevent pace.js loading bug
        setTimeout(function () {
            $('body').removeClass('pace-running').addClass('pace-done');
        }, 2000);

        // Lazy Load
        window.bLazy = new Blazy({selector: '.lazy', loadInvisible: true});

        // Object-fit pollyfill
        objectFitImages();

        this.setScrollToTopVisibility();
        $('.btn-back-to-top').click(this.goToTopPage);

        this.playerVideo();

        // Init parsley
        $('.form-parsley').each(function(index, el) {
            $(this).parsley({
                classHandler: function(field) {
                  var $parent = field.$element.closest('[data-parsley-error-wrapper]');
                  if ($parent.length) {
                    return $parent;
                  }

                  return field.$element;
                }
            });
        });

        this.tooltip();
        this.anchorUrl();
        
        $('.bk-anchors__btn').on('click', this.toggleAnchorSummary);
        this.enquireAnchor();
    },

    onWindowLoad: function (e) {
        //
    },
    onWindowScroll: function (e) {
        this.setScrollToTopVisibility();
    },
    onWindowResize: function (e) {
        this.setScrollToTopVisibility();
    },

    goToTopPage: function () {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
        Revolution.get("mde.accessible-function").giveTempFocus($('body'));
    },

    setScrollToTopVisibility: function (e) {
        var $btn = $('.btn-back-to-top');
        var offset = $(window).height();

        if ($(window).scrollTop() > offset) {
            $btn.addClass('visible');
        } else {
            $btn.removeClass('visible');
        }
    },

    playerVideo : function() {
        if($('video').length) {
            $('video').each(function(index, el) {
                var player = new Plyr(el, {
                    controls: [
                    'play-large', // The large play button in the center
                    'play', // Play/pause playback
                    'progress', // The progress bar and scrubber for playback and buffering
                    'current-time', // The current time of playback
                    'duration', // The full duration of the media
                    'mute', // Toggle mute
                    'fullscreen', // Toggle fullscreen
                    ],
                });
            });
        }
    
        if($('.video-iframe').length) {
            $('.video-iframe').each(function(index, el) {
                window.player = new Plyr(el, {
                    controls: [
                        'play-large', // The large play button in the center
                        'play', // Play/pause playback
                        'progress', // The progress bar and scrubber for playback and buffering
                        'current-time', // The current time of playback
                        'duration', // The full duration of the media
                        'mute', // Toggle mute
                        'fullscreen', // Toggle fullscreen
                    ],
                    youtube: {noCookie: false, showinfo: false, controls: 0}
                });
            });
        }
    },

    tooltip : function() {
        $('.glossify-tooltip-link').tooltipster({
            contentAsHTML: true,
            animation: 'fade',
            delay: 200,
            trigger: 'hover',
            maxWidth: 300
        });
    },

    anchorUrl : function() {
        if(window.location.hash.substr(1) != "") {
            var id = window.location.hash.substr(1);
            if($('#'+id).length) {
                if($('body.toolbar-fixed').length) {
                    var adjust = $(".page-header-wrapper").height() + 82 + $('#toolbar-bar').height();
                } else {
                    var adjust = $(".page-header-wrapper").height() + 82;
                }
    
                $('html, body').animate({
                    scrollTop: $('#'+id).offset().top - adjust
                });
            }
        }
    },

    toggleAnchorSummary : function(e) {
        var $obj = $(e.currentTarget);
        $obj.toggleClass('open');
        $('.bk-anchors__list').toggleClass('open');
        $('.bk-anchors__list').slideToggle();
    },

    enquireAnchor : function() {
        if (Modernizr.touchevents) { // touch
            $('.bk-anchors__list').css('display', 'none');
        } else {
            $('.bk-anchors__list').css('display', 'flex');            
        }

        enquire.register("screen and (max-width:63.9375em)", { //1024px
            match: _.bind(function () {
                $('.bk-anchors__list').css('display', 'none');
            }, this),
            unmatch: _.bind(function () {
                $('.bk-anchors__list').css('display', 'flex');
            }, this),
        });
    }
});
